var _g, _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBurger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M74.98,8C84.36,8,92,15.64,92,25.02v49.95C92,84.36,84.36,92,74.98,92H25.02C15.64,92,8,84.36,8,74.98V25.02 C8,15.64,15.64,8,25.02,8H74.98 M74.98,0H25.02C11.2,0,0,11.2,0,25.02v49.95C0,88.8,11.2,100,25.02,100h49.95 C88.8,100,100,88.8,100,74.98V25.02C100,11.2,88.8,0,74.98,0L74.98,0z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 26,
    fillRule: "evenodd",
    clipRule: "evenodd",
    width: 60,
    height: 8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 46,
    fillRule: "evenodd",
    clipRule: "evenodd",
    width: 60,
    height: 8
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 66,
    fillRule: "evenodd",
    clipRule: "evenodd",
    width: 60,
    height: 8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurger);
export default __webpack_public_path__ + "static/media/Burger.0dcf65cb3fe8d4a2ef5c3602859d04c4.svg";
export { ForwardRef as ReactComponent };